import HubspotForm from "./HubspotForm";

const HubspotFormWithProps = ({ blok }) => {
  return <HubspotForm hubspotFormID={blok.hubspotFormID} />;
};

export default HubspotFormWithProps;
